query getOrgDesignWorkspaceConfig($workspaceId: ID!) {
  workspace: getWorkspace(id: $workspaceId) {
    id
    name
    description
    config {
      insightsHierarchy
      orgChartAttributePolicies
      orgChartAttributeLabels
      gradeCompression
      employeeContingent
      workerSubType
      workerTimeType
    }
  }
}
